module.exports = __webpack_public_path__ + "img/vt-module-id-img.ce44fe69.svg";